import { useEffect, useState } from 'react';
import { DemeterPageType } from '../../../../Generated/Raven-Demeter';
import useLanguage from '../../../Services/Language/useLanguageHook';
import styles from './PageElementModal.module.scss';
import { IPageElementModalSelection } from './PageElementModalDefinitions';

interface IPageElementBreadcrumbProps {
    selected: IPageElementModalSelection | null | undefined;
    ignorePageNames?: boolean;
}

const PageElementBreadcrumb: React.FC<IPageElementBreadcrumbProps> = (props) => {
    const [translations, translate] = useLanguage();
    const [breadcrumb, setBreadcrumb] = useState('');

    useEffect(() => {
        if (!props.selected) {
            return;
        }
        const { selected } = props;
        const {
            pageType,
            market,
            dataSource,
            exchange,
            commodity,
            subCommodity,
            region,
            subRegion,
            pageElementType,
            subRegionName: subRegionDisplayName,
            commodityName: commodityDisplayName,
            subCommodityName: subCommodityDisplayName,
            dataFrequency,
            contractNumber,
            displayName,
        } = selected || {};

        const pageTypeName = pageType && translations.pageType[pageType] ? translations.pageType[pageType] : pageType;
        const dataSourceName = dataSource;
        const marketName = market && translations.market[market] ? translations.market[market] : market;
        const exchangeName = exchange && translations.exchange[exchange] ? translations.exchange[exchange] : exchange;
        const regionName = region && translations.region[region] ? translations.region[region] : region;
        let subRegionName = null;
        if (subRegionDisplayName) {
            subRegionName = translate(subRegionDisplayName) || subRegionDisplayName;
        } else if (subRegion) {
            subRegionName = translate(subRegion) || subRegion;
        }
        const commodityName = commodityDisplayName ? translate(commodityDisplayName) ?? commodityDisplayName : commodity;
        const subCommodityName = subCommodityDisplayName ? translate(subCommodityDisplayName) || subCommodityDisplayName : subCommodity;
        const pageElementName =
            pageElementType && translations.pageElementType[pageElementType]
                ? translations.pageElementType[pageElementType]
                : (displayName ? translate(displayName) : null) ?? pageElementType ?? '';

        const breadcrumbParts: string[] =
            ([
                pageTypeName,
                marketName,
                dataSourceName,
                exchangeName,
                commodityName,
                subCommodityName,
                regionName,
                subRegionName,
                pageElementName && !props.ignorePageNames ? pageElementName : null,
                dataFrequency,
                contractNumber && props.selected.pageType === DemeterPageType.Futures ? `${translations.words.contract} ${contractNumber}` : null,
            ].filter((part) => part !== 'null' && part !== null && part !== undefined) as string[]) || [];
        setBreadcrumb(breadcrumbParts.join(' / '));
    }, [props.selected]);

    return <div className={styles.page_element_modal_breadcrumb}>{breadcrumb}</div>;
};

export default PageElementBreadcrumb;
